/**
 * Dismiss
 * Alerts
 * @author Oliver Boermans
 */

import $ from 'jquery';
import debug from 'debug';
const log = debug('alerts');

//
// Config
// ===========
const ALERT_SELECTOR = '[data-alert]';
const ALERT_BUTTON_SELECTOR = 'button';

const hidePanel = function (alertToHide) {
    alertToHide.remove();
};

const dismissAlert = function (instance) {
    const { element, alertApi, alertId } = instance;
    $.get(alertApi, {
        id: alertId,
    });
    hidePanel(element);
};

function init() {
    const alertElements = document.querySelectorAll(ALERT_SELECTOR);
    log(alertElements);

    Array.from(alertElements).forEach((element) => {
        const alertApi = element.dataset.alertApi;
        const alertId = element.id;
        const alertButton = element.querySelector(ALERT_BUTTON_SELECTOR);

        if (alertButton) {
            alertButton.addEventListener(
                'click',
                dismissAlert.bind(null, { element, alertApi, alertId })
            );
        } else {
            log('No site alert button found.');
        }
    });
}

init();



// WEBPACK FOOTER //
// ./project/client/src/site__horticulture/components/alert-bar/dismiss.js